const stagingUserIds = [
  328975351,
  338697916,
  608134879,
  984230664,
  2013441621,
  1832230182,
  1649667375,
  1598657522,
  1338200013,
  1404852333,
  1475063456,
  1780527518,
  311532832,
  1470486820,
  973011379,
  1726287036,
  362908326,
  1668164095,
  1615124082,
];

export const validateStagingUser = (userId?: number) => {
  if (
    userId &&
    window.location.hostname === "tabligh-staging.bale.ai" &&
    !stagingUserIds.includes(userId)
  ) {
    window.location.replace("https://tabligh.bale.ai");
  }
};
